import { render, staticRenderFns } from "./agricult_product_inout.vue?vue&type=template&id=504f7ff1&"
import script from "./agricult_product_inout.vue?vue&type=script&lang=js&"
export * from "./agricult_product_inout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports